import { render, staticRenderFns } from "./RPS.vue?vue&type=template&id=085ade23&scoped=true&"
import script from "./RPS.vue?vue&type=script&lang=js&"
export * from "./RPS.vue?vue&type=script&lang=js&"
import style0 from "./RPS.vue?vue&type=style&index=0&id=085ade23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ade23",
  null
  
)

export default component.exports